import { OpportunityView } from '../../coaching-base/opportunity';

import { CommitmentGoalLookup } from './commitment-goal-lookup.model';
import { CommitmentView } from './commitment-view.model';
import { OpportunityCategory } from './opportunity-category.model';
import { UserView } from './user-view.model';

export interface PillarOneState {
    pending: {
        reload?: boolean;
        reloadUser?: boolean;
    };

    /** selected opportunity metricId */
    metricId?: number;

    /** selected opportunity */
    opportunity?: OpportunityView;

    /** selected nonKpi. commitmentId */
    nonKpiId?: number;

    commitmentGoalLookup?: CommitmentGoalLookup;
    metricIdIsInMultiple?: boolean;

    numOpportunities?: number;
    oppCategories?: OpportunityCategory[];

    nonOpportunities?: OpportunityView[];
    nonOpportunitiesOpen?: boolean;

    nonKpis?: CommitmentView[];
    nonKpisOpen?: boolean;

    user?: UserView;
}

export const defaultState = (): PillarOneState => ({
    pending: {},
});
